export const blogPosts = [
  {
    slug: 'humber-collab',
    title: 'Our Collaboration with Humber College',
    excerpt: 'How Haute-u AR teamed up with Humber’s capstone students to build real-world tech.',
    image: '/images/humber-collab.png',
    author: 'Sulochana',
    date: 'March 9, 2024'
  },
  {
    slug: 'jewelry-vton-launch',
    title: 'Jewelry VTON: Virtual Try-On for Every Style',
    excerpt: 'Our latest update allows jewelry virtual try-ons using just your camera and AI.',
    image: '/images/jewelry-vton.png',
    author: 'Kareem',
    date: 'May 1, 2024'
  },
  {
    slug: 'skintone-fashion-future',
    title: 'Why Skin Tone Matching Is the Future of Fashion',
    excerpt: 'We explore how AI and Haute-u AR use skin tone for perfect outfit recommendations.',
    image: '/images/skin-tone-ai.jpg',
    author: 'Ahmed Kabir',
    date: 'April 3, 2024'
  }
];